import { useState } from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import { RiArrowDownSLine, RiArrowUpSLine } from "react-icons/ri";

import Button from "../../components/button/ButtonController.jsx";
import InputTextarea from "../../atoms/input-textarea/InputTextareaController.jsx";
import "./styles.styl";

export const CartNote = ({ delivery }) => {
    const [isNoteExpanded, setIsNoteExpanded] = useState(false);
    const [note, setNote] = useState(delivery?.delivery_information_note || "");
    const [savedNote, setSavedNote] = useState(delivery?.delivery_information_note || "");
    const [isSaving, setIsSaving] = useState(false);
    const intl = useIntl();

    const handleSaveNote = async () => {
        if (!delivery) return;
        setIsSaving(true);
        try {
            const response = await fetch(`/api/cart/${delivery.id}`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    delivery_information_note: note,
                }),
            });
            if (!response.ok) {
                throw new Error("Failed to save note");
            }
            setSavedNote(note);
            setIsNoteExpanded(false);
        } catch (error) {
            console.error("Error saving note:", error);
        } finally {
            setIsSaving(false);
        }
    };

    const isDisabled = !delivery?.editable || isSaving;

    return (
        <div className="cart-note">
            <button
                className="cart-note__toggle"
                onClick={() => setIsNoteExpanded(!isNoteExpanded)}
            >
                {savedNote ? `${intl.formatMessage({ id: "note" })}: ${savedNote}` : intl.formatMessage({ id: "addNoteToCart" })}
                <div className="icon">
                    {isNoteExpanded ? (
                    <RiArrowUpSLine size={22} color={"gray"} />
                    ) : (
                    <RiArrowDownSLine size={22} color={"gray"} />
                    )}
                </div>
            </button>
            {isNoteExpanded && (
                <div className="cart-note__content">
                    <InputTextarea
                        className="cart-note__input"
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                        placeholder={intl.formatMessage({ id: "addNoteToCartPlaceholder" })}
                        maxLength={255}
                        disabled={isDisabled}
                    />
                    <Button
                        className="cart-note__save"
                        onClick={handleSaveNote}
                        disabled={isDisabled}
                    >
                        {isSaving
                            ? intl.formatMessage({ id: "Saving..." })
                            : intl.formatMessage({ id: "saveChanges" })}
                    </Button>
                </div>
            )}
        </div>
    );
};

CartNote.propTypes = {
    delivery: PropTypes.shape({
        id: PropTypes.string.isRequired,
        delivery_information_note: PropTypes.string,
        editable: PropTypes.bool,
    }),
};
